import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

export function PageHeader({ title, subtitle, action }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-8">
      <div>
        <h1 className="font-heading text-2xl sm:text-3xl font-semibold tracking-tight">{title}</h1>
        {subtitle && <p className="text-muted-foreground mt-1">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}

export function StatCard({ icon: Icon, label, value, accent = "primary" }) {
  const bg = { primary: "bg-primary/10 text-primary", accent: "bg-accent/15 text-accent",
    amber: "bg-amber-100 text-amber-600 dark:bg-amber-900/30 dark:text-amber-400",
    slate: "bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-300" }[accent];
  return (
    <Card className="p-5 hover:-translate-y-1 hover:shadow-lg transition-all duration-200 border-border">
      <div className={`w-10 h-10 rounded-lg flex items-center justify-center mb-3 ${bg}`}>
        <Icon className="w-5 h-5" />
      </div>
      <div className="font-heading text-2xl font-semibold">{value}</div>
      <div className="text-sm text-muted-foreground">{label}</div>
    </Card>
  );
}

const STATUS_MAP = {
  active: { label: "Ativo", cls: "bg-accent/15 text-accent" },
  pending: { label: "Pendente", cls: "bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400" },
  suspended: { label: "Suspenso", cls: "bg-destructive/15 text-destructive" },
  rejected: { label: "Rejeitado", cls: "bg-destructive/15 text-destructive" },
  in_progress: { label: "Em andamento", cls: "bg-primary/10 text-primary" },
  completed: { label: "Concluído", cls: "bg-accent/15 text-accent" },
  overdue: { label: "Atrasado", cls: "bg-destructive/15 text-destructive" },
  closed: { label: "Encerrado", cls: "bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-300" },
  requested: { label: "Solicitada", cls: "bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400" },
  confirmed: { label: "Confirmada", cls: "bg-accent/15 text-accent" },
  cancelled: { label: "Cancelada", cls: "bg-destructive/15 text-destructive" },
  rescheduled: { label: "Reagendada", cls: "bg-primary/10 text-primary" },
  paid: { label: "Pago", cls: "bg-accent/15 text-accent" },
};

export function StatusBadge({ status }) {
  const s = STATUS_MAP[status] || { label: status, cls: "bg-slate-100 text-slate-600" };
  return <span className={`inline-flex rounded-full px-2.5 py-0.5 text-xs font-medium ${s.cls}`} data-testid={`status-${status}`}>{s.label}</span>;
}

export function EmptyState({ icon: Icon, title, desc, action }) {
  return (
    <div className="text-center py-16 border border-dashed border-border rounded-2xl">
      {Icon && <div className="w-12 h-12 rounded-xl bg-secondary flex items-center justify-center mx-auto mb-4"><Icon className="w-6 h-6 text-muted-foreground" /></div>}
      <h3 className="font-heading font-medium text-lg">{title}</h3>
      {desc && <p className="text-muted-foreground text-sm mt-1 max-w-sm mx-auto">{desc}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}

export function Disclaimer() {
  return (
    <p className="text-xs text-muted-foreground border-t border-border pt-4 mt-8">
      Os conteúdos e exercícios desta plataforma possuem caráter educativo e complementar e não substituem
      avaliação, diagnóstico ou acompanhamento profissional.
    </p>
  );
}
